import styled from 'styled-components';

export const ProvisioningSuccessAlert = styled.div`
  s-icon {
    color: #FFF !important;
    background-color: var(--color-banner-success-bg) !important;
  }
`;
